import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../Redux/Slices/authslice";
import addDoctor from "../modules/AddDoctor/AddDoctorSlice";
import loadingSlice from "../modules/loading/loadingSlice";
import appointmentsReducer from '../modules/WaiverOff/appointmentsSlice';
import refreshNoti from '../modules/fetchNoti/fetchNotiSlice'
import rescheduleAppointment from "../modules/RescheduleAppointment/RescheduleAppointmentSlice"

export const store = configureStore({
  reducer: {
    user: userReducer,
    addDoctor,
    loading: loadingSlice,
    appointments: appointmentsReducer,
    refreshNoti,
    rescheduleAppointment
  },
});
